// extracted by mini-css-extract-plugin
export default {"loginSlider":"login-slider_loginSlider__6XPo4"};